import { useState, useCallback, useEffect, FormEvent } from 'react';
import styles from './login.module.scss';
import WarningIcon from '../../../assets/icons/warning.svg?react';
import RedWarningIcon from '../../../assets/icons/red-warning.svg?react';
import { TextInput, TextInputValue } from '../../../components/text-input/TextInput';
import { Link } from 'react-router-dom';
import ParentAuthPageLayout from '../../../components/auth-page-layout/HsaAuthPageLayout';
import Button from 'src/components/button/Button';
import { useHsaLoginMutation } from '../../../hooks/useHsaLoginMutation';
import { isEmptyObject, validatePassword, validateEmail } from '../../../utils/validation';
import { useCheckUserStatusMutation } from '@src/api/graphql-codegen';
import Spinner from '@components/spinner/Spinner';
import { useAuthToken } from '@src/hooks/useAuthToken';
import { logger } from '../../../utils/logger';

const emptyErrors = {
  email: '',
  password: ''
};

function Login() {
  const [login, , { loading, error }] = useHsaLoginMutation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [errors, setErrors] = useState(emptyErrors);
  const [enableLogin, setEnableLogin] = useState(false);
  const [isPassword, setIsPassword] = useState(false);
  const [verified, setVerified] = useState(false);
  const { removeVisitProfile } = useAuthToken();

  const [heaCheckUserStatus, {loading: checking}] = useCheckUserStatusMutation({
    onCompleted(data) {
      if (data.heaCheckUserStatus === "verified") {
        setVerified(true);
        removeVisitProfile();
      } else if (data.heaCheckUserStatus.toLocaleLowerCase() === "passwordset" || data.heaCheckUserStatus.toLocaleLowerCase() === "nameset") {
        setIsPassword(true);
      } else {
        setVerified(false)
        setIsPassword(true);
      }
    },
    onError(e) {
      if (e.message) {
        if (isPassword || e.message.indexOf("you have entered is incorrect, please try again.") === -1) {
          logger.info('error', e.message);
          setErrors(errs => ({ ...errs, email: e.message }));
        } else {
          setIsPassword(true);
        }
      } else {
        setIsPassword(true);
      }
    }
  })

  useEffect(() => {
    if (validateEmail(email)) {
      setVerified(false)
      setEnableLogin(false)
    } else {
      setEnableLogin(true)
    }
  }, [email]);

  const handleChange = useCallback((setter, key: keyof typeof emptyErrors) => (value: TextInputValue) => {
    setErrors({
      ...errors,
      [key]: '',
    });
    setter(value as string);
  },[errors])

  const handleSubmit = () => {
    setVerified(false)
    const errors: any = {};

    if (isEmptyObject(email)) {
      errors.email = 'Please add a email.';
    }

    if (isEmptyObject(password)) {
      errors.password = 'Please add a password.';
    }

    if (validateEmail(email)) {
      errors.email = validateEmail(email);
    }

    let p = validatePassword(password)
    if (p) {
      errors.password = p;
    }

    login(email, password);
  }

  const handleCheckStatus = () => {
    setVerified(false)
    setIsPassword(false);
    const errors: any = {};

    if (validateEmail(email)) {
      errors.email = validateEmail(email);
    }

    heaCheckUserStatus({
      variables: {
        input: { email }
      }
    });
  }

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    isPassword ? handleSubmit() : handleCheckStatus()
  }

  return (
    <ParentAuthPageLayout onSubmit={onSubmit} title={'Welcome Back!'} isParentAuth>
      <div className={styles.loginSubTitle}>{'Please sign in to Continue'}</div>
      <TextInput
        allowSpecialCharacters
        className={styles.input} onChange={handleChange(setEmail, 'email')}
        value={email} label={'Email*'} placeholder={'Email'} id={'email'}
        hasError={!!errors.email} subTitle={errors.email}
      />
      {isPassword && <TextInput allowSpecialCharacters className={styles.input} onChange={handleChange(setPassword, 'password')} value={password} label={'Password*'}
                 placeholder={'Password'} id={'password'} type={'password'}/>}
      {verified && <div className={styles.alertView}>
        <RedWarningIcon width="36" height="36"/>
        <span className={styles.alertDetail}>You have not created a password yet. We have sent you an email with a link to create your password.</span>
      </div>}
      {error?.message &&
        <div className={styles.warnView}>
          <WarningIcon width="32" height="32" className={styles.arrowIcon}/>
          <span className={styles.warnDetail}>{error?.message ? error?.message : 'We cannot find an account with that email address.'}</span>
        </div>
      }
      <Button disabled={!enableLogin || loading || checking} size="small" className={enableLogin ? styles.submit: styles.submitDisable} onClick={isPassword ? handleSubmit : handleCheckStatus} label={'Sign in'} leftIcon={loading || checking ? <Spinner width={20} height={20} /> : undefined}/>
      {isPassword && <div className={styles.actionsWrapper}>
        <Link className={styles.link} to={'/forgot-password'}>Forgot password?</Link>
      </div>}
      {/* <div className={styles.clickText}>Haven’t registered Yet? <a className={styles.clickLink} href="/registration">Click Here</a></div> */}
    </ParentAuthPageLayout>
  )
};

export default Login;
